import "./form-transaction-service.scss";
import { useFormContext } from "react-hook-form";
import { TransactionServiceFormSchema } from "@factory/form/form.rule";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import { LabelValue } from "@shared/models/label-value.interface";
import { GetResponseServiceModel } from "@factory/model/query-model-service";
import { useQyGetService } from "@factory/query/service.query";
import { useEffect, useState } from "react";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { GetServiceDto } from "@api/api";
import ChildInfo from "@core/ui/child-info/child-info";
import { isNil } from "lodash-es";
import { Checkbox } from "primereact/checkbox";

type InputFormSchema = TransactionServiceFormSchema;
export interface FormTransactionServiceProps {
  member?: LabelValue;
  hideAdvanceBooking?: boolean;
}
export function FormTransactionService({
  hideAdvanceBooking,
  member,
}: FormTransactionServiceProps) {
  const { control, setValue, watch, register } =
    useFormContext<TransactionServiceFormSchema>();
  const [serviceList, setServiceList] = useState<LabelValue[]>([]);
  const [serviceData, setServiceData] = useState<GetServiceDto[]>([]);
  const serviceId = watch("service");
  const serviceDataForm = watch("serviceData");
  const [checked, setChecked] = useState(false);

  const handleServiceSuccess = (data: GetResponseServiceModel) => {
    if (!data || data.data?.length === 0) {
      return;
    }

    const responseData = data.data || [];
    const serviceLabelValue = LabelValue.MapArray(
      responseData,
      (item) => item.name,
      (item) => item.code
    );
    setServiceData(responseData);
    setServiceList(serviceLabelValue);
  };
  useQyGetService(
    "",
    9999,
    0,
    undefined,
    undefined,
    true,
    handleServiceSuccess
  );

  useEffect(() => {
    if (!serviceData || serviceData.length === 0) return;

    const service = serviceData.filter((item) => item.code === serviceId);
    const amount = service[0]?.amount ?? 0;
    setValue("amount", amount);
  }, [serviceId, serviceData]);

  useEffect(() => {
    if (isNil(member)) return;
    setValue("member", member.value);
  }, [member]);

  return (
    <div id="FormTransactionService" className="transaction-service">
      <input type="hidden" {...register("member")} />

      {member ? (
        <div>
          <ChildInfo name={member.label} />
        </div>
      ) : null}

      <DropdownControl<InputFormSchema>
        control={control}
        name="service"
        label="Service (Required)"
        className="w-full"
        containerClassName="pb-2"
        placeholder="Select a service"
        options={serviceList}
        onSelect={(item) => {
          const selectedItem = serviceData.find((x) => x.code === item);
          setValue("serviceData", selectedItem);
          setValue("amount", item.amount || 0);
        }}
      />

      {serviceDataForm?.description ? (
        <>
          <small className="block mt-4">Description</small>
          <p className="block mb-10">{serviceDataForm.description}</p>
        </>
      ) : null}
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amount"
        label="Amount"
        className="w-full"
        containerClassName="pb-2"
        placeholder="Enter amount"
        disabled
      />

      {!hideAdvanceBooking ? (
        <div className="flex align-items-center my-4">
          <Checkbox
            inputId="advanceBooking"
            onChange={(e) => setChecked(e.checked as boolean)}
            checked={checked}
          />
          <label htmlFor="advanceBooking" className="ml-2">
            Show Advance Booking
          </label>
        </div>
      ) : null}

      {checked ? (
        <>
          <InputDateControl<InputFormSchema>
            control={control}
            name="date"
            label="Date (Optional - Leave blank if starts now)"
            className="w-full"
            containerClassName="pb-2"
            placeholder="Enter date"
          />
          <InputDateControl<InputFormSchema>
            control={control}
            type="time"
            name="time"
            label="Time (Optional - Leave blank if starts now)"
            className="w-full"
            containerClassName="pb-2"
            placeholder="Enter time"
          />
        </>
      ) : null}
    </div>
  );
}

export default FormTransactionService;
